import { createContext, useContext } from 'react'

import { CRBIdLicenseDetails } from '~bank-crb-monitor/types'

type CRBIdLicenseContextValue = {
  data: CRBIdLicenseDetails
}

export const CRBIdLicenseContext = createContext<CRBIdLicenseContextValue | undefined>(undefined)

export const useCRBIdLicenseContext = () => {
  const context = useContext(CRBIdLicenseContext)
  if (!context) {
    throw new Error('useCRBIdLicenseContext must be used within a CRBIdLicenseContext.Provider')
  }
  return context
}
